import { t } from '../../i18n/t';
import { useClientApp } from '../context';
import { usePage, type Crumb } from '../page';
import { lohnPath } from './labels';

// Titel, Pfad und Zurück-Ziel im Bereich Mitarbeiter: Start › Mitarbeiter › <Firma> › <Seite>.
// Mit nur einer Firma gibt es die Firmenwahl nicht, „Mitarbeiter“ ist dann kein Link und Zurück springt zur Übersicht.
export function useLohnPage(p: { title: string; clientId?: string; clientName?: string; sub?: string }) {
  const { clients, clientName } = useClientApp();
  const one = clients.length === 1;
  const levels: Crumb[] = [
    { label: t('Start'), to: '/app' },
    { label: t('Mitarbeiter'), to: one ? undefined : lohnPath() },
  ];
  if (p.clientId) levels.push({ label: p.clientName ?? clientName(p.clientId), to: lohnPath(p.clientId) });
  if (p.sub) levels.push({ label: p.sub });
  const last = levels.length - 1;
  const crumbs = levels.map((c, i) => (i === last ? { label: c.label } : c));
  let back = levels[last - 1]?.to ?? '/app';
  if (last === 2 && one) back = '/app';
  usePage({ title: p.title, crumbs, back, nav: 'mitarbeiter' });
}
